import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_components");

Vue.use(Router);

const routes = [{
        path: "/",
        component: _import("www/main"),
        children: [{
            path: "/",
            name: "index",
            component: _import("www/index"),
        }],
    },

    {
        path: "/israel",
        component: _import("israel/index"),
        children: [{
                path: "/",
                component: _import("israel/compete-Pre"),
            },
            {
                path: "/israel/login",
                component: _import("israel/login"),
            },
            {
                path: "/israel/userIndex",
                component: _import("israel/userIndex"),
            },
        ],
    },
    {
        path: "/myc2025",
        component: _import("myc2025/main"),
        children: [{
                path: "/myc2025",
                component: _import("myc2025/index"),
            },
        ],
    },
    {
        path: "/gsc2025",
        component: _import("gsc2025/main"),
        children: [{
                path: "/gsc2025",
                component: _import("gsc2025/index"),
            },
        ],
    },
];


function addCRouter(channel, dir){
    if(dir == undefined) dir = channel;

    routes.push({
        path: `/${channel}`,
        component: _import(`${dir}/index`),
        children: [{
                path: "/",
                name: channel + "#index",
                component: _import(`${dir}/compete-Pre`),
            },
            {
                path: `/${channel}/login`,
                name: channel + "#login",
                component: _import(`${dir}/login`),
            },
            {
                path: `/${channel}/signup`,
                name: channel + "#signup",
                component: _import(`${dir}/signup`),
            },
            {
                path: `/${channel}/userIndex`,
                name: channel + "#userIndex",
                component: _import(`${dir}/userIndex`),
            },
            {
                path: `/${channel}/rank`,
                component: _import(`${dir}/rank`),
            },
            {
                path: `/${channel}/userGroups`,
                component: _import(`${dir}/user-groups`),
            },
        ],
    })
}

// addCRouter("demo", "demo_0_v2"); // 基准模版

// 全国
addCRouter("teacher"); // 教师培训及考核

addCRouter("2024", "2024_global");  // 第六届ICode国际青少年编程活动
addCRouter("2025", "2025");  // 第七届ICode国际青少年编程活动

addCRouter("mgtv"); // 芒果TV半决赛
addCRouter("mgtv_semi", "mgtv"); // 芒果TV半决赛
addCRouter("mgtv_final", "mgtv"); // 芒果TV半决赛

//wrc
addCRouter("wrc_learn"); // 24年wrc训练平台
// wrc无需增加新的router

// 福建省
// addCRouter("qz2024");

//河南
// addCRouter("hn2024_learn"); //河南省ICode专属体验平台 2024-12-31 结素
// addCRouter("xinyang03");//信阳市第三届中小学生创意编程大赛ICode太空探险挑战赛—选拔赛 2024-10-20 结束

// 山东省
// addCRouter("xha2024"); //  青岛西海岸新区第四届人工智能教育竞赛 2025-01-31 结束
// addCRouter("dt2024"); // 定陶区人工智能教育编程启蒙平台

// 四川
addCRouter("SCSSN2024"); // “新时代·蜀少年”2024年四川省青少年文化艺术展演（科技创新类）


// WRC相关活动
routes.push({
    path: "/wrc",
    component: _import("wrc/index"),
    children: [{
        name: "wrc_list",
        path: "/",
        component: _import("wrc/compete-Pre"),
    }],
})

routes.push({
    path: "/wrc_:channel",
    name: "wrc_main",
    component: _import("wrc/template/main"),
    children: [{
            name: "wrc_index",
            path: "/wrc_:channel/",
            component: _import("wrc/template/index"),
        },
        {
            name: "wrc_login",
            path: "/wrc_:channel/login",
            component: _import("wrc/template/login"),
        },
        {
            name: "wrc_signup",
            path: `/wrc_:channel/signup`,
            component: _import("wrc/template/signup"),
        },
        {
            name: "wrc_userIndex",
            path: `/wrc_:channel/userIndex`,
            component: _import("wrc/template/userIndex"),
        },

    ],
})

routes.push({
    path: "/:channel",
    name: "contest_main",
    component: _import("template/main"),
    children: [{
            name: "contest_index",
            path: "/:channel/",
            component: _import("template/index"),
        },
        {
            name: "contest_login",
            path: "/:channel/login",
            component: _import("template/login"),
        },
        {
            name: "contest_signup",
            path: `/:channel/signup`,
            component: _import("template/signup"),
        },
        {
            name: "contest_userIndex",
            path: `/:channel/userIndex`,
            component: _import("template/userIndex"),
        },

    ],
})

// 加到最后面；
routes.push(
    {
        path: "/404",
        name: "t404",
        component: () =>
            import ("../components/common/t404.vue"),
    },
)

routes.push(
    {
        path: "*",
        redirect: "/404",
    },
)


const router = new Router({
    //后端支持可开
    mode: "history",
    routes: routes,

    scrollBehavior: () => ({
        y: 0,
    }),
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js